import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ResturantData } from "@/types/globalTypes";

export type SettingsCardType = {
  icon: React.ReactNode;
  title: string;
  description: string;
  href?: string;
  isSoon?: boolean;
  haveAccess: boolean;
  shouldShow?: boolean;
  needSubscription?: boolean;
  action?: () => void;
};

function SettingsCard({
  icon,
  title,
  description,
  href,
  isSoon,
  haveAccess,
  shouldShow,
  needSubscription,
  action
}: SettingsCardType) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

    const ResturantData = useSelector(
      (state: { resturant: { resturantData: ResturantData } }) =>
        state.resturant.resturantData,
    );
  
    const WithoutPlan = ResturantData?.subscription === null;
  
  return (
    <button
      onClick={action ? action : () => !!href && haveAccess && navigate(href)}
      className={`group relative flex flex-col items-center justify-center overflow-hidden rounded-lg border border-gray-300 bg-white px-3 ${!shouldShow && "hidden"} py-7 shadow-sm xl:px-5 ${
        !href || !haveAccess ? "cursor-not-allowed" : ""
      }`}
    >
      <div className="group text-sidebar">{icon}</div>
      <h3
        className={`mt-3 text-base font-semibold capitalize text-gray-500 transition-colors md:text-sm ${
          href ? "group-hover:text-sidebar" : ""
        }`}
      >
        {title}
      </h3>
      <p className="mt-1 px-2 text-center text-sm capitalize text-gray-400">
        {description}
      </p>

      {
  needSubscription && WithoutPlan ? (
    <span
      className={`absolute top-[20px] w-[8rem] bg-sidebar py-1 font-semibold  text-skyblue ${
        isArabic ? "end-[-30px] -rotate-[45deg]" : "start-[-30px] rotate-[-45deg]"
      }`}
    >
      {t("subscribtionSettings.pro")}
    </span>
  ) : isSoon ? (
    <span
      className={`absolute top-[20px] w-[8rem] bg-[#ffc62a] py-1 font-semibold text-[#907017] ${
        isArabic ? "end-[-30px] -rotate-[45deg]" : "start-[-30px] rotate-[-45deg]"
      }`}
    >
      {t("soon")}
    </span>
  ) : !haveAccess && !isSoon ? (
    <span
      className={`absolute top-[20px] w-[8rem] bg-gray-400 py-1 font-semibold text-gray-600 ${
        isArabic
          ? "end-[-30px] -rotate-[45deg] text-base"
          : "start-[-30px] rotate-[-45deg] text-sm"
      }`}
    >
      {t("notInstalled")}
    </span>
  ) : null
}

      
    </button>
  );
}

export default SettingsCard;
